/**
 * LandingPricing - Pricing section and CTA for the landing page
 */
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Button } from '../components/ui/button'
import { Card } from '../components/ui/card'
import { Badge } from '../components/ui/badge'

export function PricingSection() {
  return (
    <section id="pricing" className="scroll-mt-16">
      <div className="container px-4 md:px-6 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <Badge variant="outline" className="mb-4">Pricing</Badge>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Competitive pricing for African businesses
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Volume discounts, local currency billing, and flexible payment terms.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
          <Card className="text-center p-6">
            <div className="text-3xl mb-3">{'\u{1F4E7}'}</div>
            <h3 className="font-semibold mb-2">Microsoft 365</h3>
            <p className="text-2xl font-bold text-primary mb-1">From R99</p>
            <p className="text-sm text-muted-foreground">per user/month</p>
          </Card>
          <Card className="text-center p-6 border-primary">
            <div className="text-3xl mb-3">{'\u{1F6E1}\uFE0F'}</div>
            <h3 className="font-semibold mb-2">Security Suite</h3>
            <p className="text-2xl font-bold text-primary mb-1">From R49</p>
            <p className="text-sm text-muted-foreground">per device/month</p>
          </Card>
          <Card className="text-center p-6">
            <div className="text-3xl mb-3">{'\u{1F4BE}'}</div>
            <h3 className="font-semibold mb-2">Cloud Backup</h3>
            <p className="text-2xl font-bold text-primary mb-1">From R29</p>
            <p className="text-sm text-muted-foreground">per user/month</p>
          </Card>
        </div>

        <div className="text-center">
          <p className="text-muted-foreground mb-4">
            Prices vary by product and volume. Sign in to see your personalized pricing.
          </p>
          <Button size="lg" asChild>
            <Link to="/login">
              View Full Catalog
              <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}

export function CtaSection() {
  return (
    <section className="bg-primary text-primary-foreground">
      <div className="container px-4 md:px-6 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Ready to get started?
          </h2>
          <p className="text-lg opacity-90 mb-8">
            Join thousands of African businesses already saving time and money
            on their software licenses.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" variant="secondary" className="text-base px-8" asChild>
              <Link to="/login">
                Get Started Now
                <ArrowRight className="h-4 w-4 ml-2" />
              </Link>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-base px-8 bg-transparent border-primary-foreground/30 hover:bg-primary-foreground/10"
              asChild
            >
              <Link to="/contact">Talk to Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
